import type { ChaveConfiguracao } from '@arena/shared/schemas';
import { api } from './cliente.js';

/**
 * As chamadas da tela de configurações da arena — pendência do
 * documento 02, sem tela no protótipo (ver `#m-plano` como padrão).
 */

export interface ItemDoCatalogo {
  readonly chave: string;
  readonly rotulo: string;
  readonly descricao: string;
}

export interface QuadraDaArena {
  readonly id: string;
  readonly nome: string;
  readonly superficie: string;
  readonly corPadrao: string;
  readonly ordem: number;
}

export interface ConfiguracoesDaArena {
  readonly valores: Record<ChaveConfiguracao, unknown>;
  readonly catalogo: readonly ItemDoCatalogo[];
  readonly quadras: readonly QuadraDaArena[];
}

export const configuracoesApi = {
  listar(): Promise<ConfiguracoesDaArena> {
    return api<ConfiguracoesDaArena>('/configuracoes');
  },

  gravar(chave: ChaveConfiguracao, valor: unknown): Promise<{ chave: string; valor: unknown }> {
    return api<{ chave: string; valor: unknown }>(`/configuracoes/${chave}`, {
      metodo: 'PUT',
      corpo: { valor },
    });
  },
};
